import { color } from '@nuvolo/nuux-theme/utils';

export const borderRadius = 'var(--border-radius-base)';
export const border = `1px solid ${color('primary', 'light3')}`;
export const backgroundColor = color('custom', 'dataGridBackground');
